import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ArrowRight } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'
import { TAKE_ME_THERE } from './helpFeedbackText'

/** The link's own words, for "Take me there: <words>". */
function textOf(node: unknown): string {
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(textOf).join('')
  if (node && typeof node === 'object' && 'props' in node) {
    return textOf((node as { props: { children?: unknown } }).props.children)
  }
  return ''
}

/**
 * An answer, in the chat's typography (the classes `DocMarkdown` uses). An in-app link routes in the
 * app with "Take me there" beside it, and the panel stays open; any other link opens a new tab.
 */
export function AnswerMarkdown({ content }: { content: string }) {
  const navigate = useNavigate()
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none *:first:mt-0 *:last:mb-0">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a({ href, children }) {
            if (href && href.startsWith('/') && !href.startsWith('//')) {
              const words = textOf(children).trim()
              return (
                <>
                  <Link to={href}>{children}</Link>{' '}
                  <button
                    type="button"
                    aria-label={words ? `${TAKE_ME_THERE}: ${words}` : TAKE_ME_THERE}
                    onClick={() => navigate(href)}
                    className="not-prose inline-flex items-center gap-1 rounded-md border border-border px-1.5 py-0.5 align-baseline text-xs font-medium text-primary outline-none hover:bg-accent focus-visible:ring-[3px] focus-visible:ring-ring/50"
                  >
                    {TAKE_ME_THERE}
                    <ArrowRight aria-hidden className="size-3" />
                  </button>
                </>
              )
            }
            return (
              <a href={href} target="_blank" rel="noreferrer noopener">
                {children}
              </a>
            )
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
